import { render } from "./FooterImages.vue?vue&type=template&id=bf60a702&scoped=true"
import script from "../js/footer-images.js?vue&type=script&lang=js"
export * from "../js/footer-images.js?vue&type=script&lang=js"

import "./FooterImages.vue?vue&type=style&index=0&id=bf60a702&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf60a702"]])

export default __exports__